import React from "react";
import Navbar from "./Navbar";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <Navbar />
      <main className="w-full px-4 md:px-6 xl:px-16 xl:py-10 lg:px-10 lg:py-6 md:py-8 py-6 bg-background">
        {children}
      </main>
    </>
  );
};

export default Layout;
